const BASE_URL = 'https://hmcore.xyz-app.com';
// const BASE_URL = 'http://127.0.0.1:8000';

// https://hmetl.hyperminds.tech/projects/
// http://127.0.0.1:8000

                         

export default BASE_URL;

